export default __webpack_public_path__ + "static/media/For-Side.37980598.gif";